module.exports = __webpack_public_path__ + "img/Borussia-Dortmund.b96bc615.png";